import { CmsConfig } from '@spartacus/core';

export const defaultOccCmsModuleConfig: CmsConfig = {
  backend: {
    occ: {
      endpoints: {
        component: 'users/${userId}/cms/components/${id}',
        components: 'users/${userId}/cms/components',
        pages: 'users/${userId}/cms/pages',
        page: 'users/${userId}/cms/pages/${id}',
      },
    },
  },
  cmsComponents: {},
};
